import styled from "styled-components";
import { Dialog } from "@material-ui/core";

export const DialogWrapper = styled(Dialog)`
	.MuiBackdrop-root {
		background-color: rgba(0, 0, 0, 0.8);
	}

	.MuiDialog-paper {
		color: #fff;
		position: inherit;
		overflow: visible;
		background: transparent;
	}

	.confetti {
		width: 100%;
		height: 100%;
		position: absolute;
	}

	.main-container {
		color: #fff;
		border: 3px solid #ffea7d;
		width: 550px;
		border-radius: 20px;
		padding: 20px;
		background-color: #771c1c;
		text-align: center;

		.text {
			font-size: 28px;
		}
		/* .buttons{
            display: ;
        } */

		.btn-container {
			background: linear-gradient(to top, #ffe6ed, #875262, #fddbdb);
			border-radius: 50px;
			margin: 30px auto;
			padding: 4px;
			animation: rounded 20s linear infinite;
			transition: opacity 0.3s ease-in-out;
			width: fit-content;
			.done-btn {
				&.enable {
					cursor: pointer;
					filter: blur(0px);
				}
				border-radius: 35px;
				background-size: 400%;
				box-shadow: inset 0 0 9.8px 0.2px #000, inset 0px 3px 0 0 rgb(255 255 255 / 41%);
				font-size: 28px;
				padding: 5px 40px;
				-webkit-transition: opacity 0.3s ease-in-out;
				transition: opacity 0.3s ease-in-out;
				width: auto;
				z-index: 1;
				border: 2px solid #771c1c;
				color: #771c1c;
				background-image: radial-gradient(circle at 0 0, #ffdc00, #de602a);
			}
			@keyframes rounded {
				0% {
					background-position: 0 0;
				}
				50% {
					background-position: 400% 0;
				}
				100% {
					background-position: 0 0;
				}
			}
		}
		.green {
			background: linear-gradient(45deg, #4caf50, rgb(255, 255, 255), #4caf50, rgb(255, 255, 255)) 0% 0% / 400%;
			box-shadow: 0px 0px 11px 4px #378b06;
		}
		.red {
			background: linear-gradient(45deg, rgb(255, 0, 0), rgb(255, 255, 255), rgb(255, 0, 0), rgb(255, 255, 255)) 0% 0% / 400%;
			box-shadow: 0px 0px 11px 4px #ff000094;
		}
	}
`;
